import axios from "axios";

const services = {
    getAuthToken: async (Email) => {
    const result = await axios.get(`/auth/token`, {
      headers: {
        Email: Email,
      },
    });
    return result.data;
    },

    getGraphToken: async (Email) => {
        const result = await axios.get(`/auth/graphtoken`, {
            headers: {
                Email: Email,
            },
        });
        return result.data;
    },
  getUserProfileInfo: async (Email) => {
    const result = await axios.get(`/PIPSIndexing/GetUserProfileInfo`, {
      headers: {
        Email: Email,
      },
    });
    return result.data;
    },

    uploadFile : async (file) => {
        const formData = new FormData();
        formData.append("file", file);

        const response = await axios.post("/PIPSIndexing/upload", {
            method: "POST",
            body: formData,
        });

        const result = await response.json();
        return result;
    },

  getLocationSpecificInfo: async (
    CompLocId,
    CompanyID,
    UserID,
    SubmissionStatusID = -1,
    LoggedInCompLocID,
    ViewAllCompLocs = false,
    ConfidentialDocs,
    EmailIndex = false,
    PolicyNumber,
    SubmissionNumber,
  ) => {
    const result = await axios.get(`/PIPSIndexing/GetLocationSpecificInfo`, {
      headers: {
        CompLocId,
        CompanyID,
        UserID,
        SubmissionStatusID,
        LoggedInCompLocID,
        ViewAllCompLocs,
        ConfidentialDocs,
        EmailIndex,
        PolicyNumber,
        SubmissionNumber,
      },
    });
    return result.data;
  },
   GetIdsByImageKeywordSelect: async (
    imgKeywordId,
    CompLocID,
    EmailIndex,
    policyID,
    policyDetailId,
    userId,
    txtSubject
  ) => {
    const result = await axios.get(`/Binding/GetIdsByImageKeywordSelect`, {
      headers: {
        imgKeywordId,
        CompLocID,
        EmailIndex,
        policyID,
        policyDetailId,
        userId,
        txtSubject
      },
    });
    return result.data;
  },
    bindLocation: async (Email) => {
    const result = await axios.get(`/PIPSIndexing/GetLocation`, {
      headers: {
        Email: Email,
      },
    });
    return result.data;
  },
  getCriteriaList: async (CompLocID) => {
    const result = await axios.get(`/PIPSIndexing/GetCriteriaList?CompLocID=${CompLocID}`);
    return result.data;
  },
  selDocumentType: async (userLoginName, useVpn, CompLocID, Criteria) => {
    const result = await axios.get(
      `/PIPSIndexing/SelDocumentType?userLoginName=${userLoginName}&useUPN=${useVpn}&Criteria=${Criteria}&CompLocID=${CompLocID}`
    );
    return result.data;
  },
  selUserGroupsForPerson: async (userId) => {
    const result = await axios.get(`/PIPSIndexing/SelUserGroupsForPerson?userId=${userId}`);
    return result.data;
  },
  selQueuesForUserGroup: async (userGroupId, useVpn) => {
    const result = await axios.get(
      `/PIPSIndexing/SelQueuesForUserGroup?userGroupId=${userGroupId}&activeOnly=${activeOnly}`
    );
    return result.data;
  },
  getPoliciesDetailsForInsured: async (
    InsuredID,
    SubmissionStatusID,
    LoggedInCompLocID,
    ViewAllCompLocs,
    UserID
  ) => {
    const result = await axios.get(`/PIPSIndexing/GetPoliciesDetailsForInsured`, {
      headers: {
        InsuredID,
        SubmissionStatusID,
        LoggedInCompLocID,
        ViewAllCompLocs,
        UserID
      },
    });
    return result.data;
  },
  getRecentInsured: async (CompanyId, UserID, InsuredId) => {
    const result = await axios.get(`/PIPSIndexing/GetRecentInsured`, {
      headers: {
        CompanyId,
        UserID,
        InsuredId,
      },
    });
    return result.data;
  },
  searchByCriteria: async (CompanyId, CompLocId, Criteria, SearchText, UserID) => {
    const result = await axios.get(`/Search/SearchByCriteria`, {
      headers: {
        CompanyId,
        CompLocId,
        Criteria,
        SearchText,
        UserID
      },
    });
    return result.data;
  },
  getUserGroupsForPerson: async (userId) => {
    const result = await axios.get(`/Binding/GetUserGroupsForPerson`, {
      headers: {
        userId,
      },
    });
    return result.data;
  },
  getQueuesForUserGroup: async (userGroupId, activeOnly = true) => {
    const result = await axios.get(`/Binding/GetQueuesForUserGroup`, {
      headers: {
        userGroupId,
        activeOnly,
      },
    });
    return result.data;
  },
  getPersonUserGroupXRef: async (UserGroupId, ActiveOnly, ActiveAndExpiredWithOpenTask) => {
    const result = await axios.get(`/Binding/GetPersonUserGroupXRef`, {
      headers: {
        UserGroupId,
        ActiveOnly,
        ActiveAndExpiredWithOpenTask,
      },
    });
    return result.data;
  },
  getPolicyChecklistForPolicy: async (PolicyId, Completed, CompLocId, IncludeNone) => {
    const result = await axios.get("/Binding/GetPolicyChecklistForPolicy", {
      headers: {
        PolicyId,
        Completed,
        CompLocId,
        IncludeNone,
      },
    });
    return result.data;
  },
  getTaskTypes: async (taskTypeId, userGroupId) => {
    const result = await axios.get("/Binding/GetTaskTypes", {
      headers: {
        taskTypeId,
        userGroupId,
      },
    });
    return result.data;
  },
  getDocumentType: async (CompLocID) => {
    const result = await axios.get("/Binding/GetDocumentTypes", {
      headers: {
        CompLocID
      },
    });
    return result.data;
  },
    getDocumentClass: async (Criteria, CompLocID, ConfidentialDocs) => {
    const result = await axios.get("/Binding/GetDocumentClass", {
      headers: {
        Criteria,
        CompLocID,
        ConfidentialDocs,
      },
    });
    return result.data;
  },
  getPolicyChecklistForPolicy: async (PolicyId, Completed, CompLocID, IncludeNone) => {
    const result = await axios.get("/Binding/GetPolicyChecklistForPolicy", {
      headers: {
        PolicyId,
        Completed,
        CompLocID,
        IncludeNone,
      },
    });
    return result.data;
  },
  getNotes: async (policyId, url) => {
    const result = await axios.get(url, {
      headers: {
        policyId
      }
    });
    return result.data;
  },
  addNotes: async (body = {}) => {
    const result = await axios.post(
      `/Notepad/AddPolicyNotes`,
      body
    );
    return result.data;
  },
  deleteNotes: async (userLoginName, compLocID, policyID) => {
    const result = await axios.delete(
      `/Notepad/DeletePolicyNotes?userLoginName=${userLoginName}&compLocID=${compLocID}&policyID=${policyID}`
    );
    return result.data;
  },
  getPriorityList: async () => {
    const result = await axios.get("/Binding/getPriority");
    return result.data;
  },
};

export default services;
